exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch-link[data-v-470cd1a1]{cursor:pointer;display:inline-block;color:#397efd;font-size:14px;margin-top:20px}", ""]);

// exports
